var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthletisme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2772",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2776"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2786"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2784"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2778",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2782",
    clipPath: "url(#clipPath2786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2788",
    transform: "translate(512,436.3042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -256.095 C -355.675,0 -436.4,-80.725 -436.4,-180.304 v 0 c 0,-99.58 80.725,-180.304 180.305,-180.304 H 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2790"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2792",
    transform: "translate(512,136.3051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -256.095 C -322.201,0 -375.79,53.589 -375.79,119.695 v 0 c 0,66.106 53.589,119.695 119.695,119.695 H 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2794"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2796",
    transform: "translate(512,496.9135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -256.096 c -133.052,0 -240.913,-107.861 -240.913,-240.913 v -10e-4 c 0,-133.053 107.861,-240.913 240.913,-240.913 H 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2798"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2800",
    transform: "translate(426.9381,15.0865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 121.219",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2802"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2804",
    transform: "translate(396.9362,136.3051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 149.697 H 71.729 L 56.728,119.695 71.729,89.693 H 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2806"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthletisme);
export default __webpack_public_path__ + "static/media/athletisme.8ef79d1db7d6755410fa5ba14e1720ac.svg";
export { ForwardRef as ReactComponent };